import { environment } from '../environments/environment';
const ɵ0 = () => environment.appName;
export class AppModule {
}
export { ɵ0 };
